/* Anemoia — turn Dawn's country picker into a currency picker.

   Dawn lists every shippable country (237, Afghanistan first) behind a search box. Shoppers don't
   want to pick a country — they want the price in their money. And a country list is redundant:
   Greece, France and Italy are all just "EUR".

   Dawn's control is left intact underneath — its markup, its disclosure, its POST to /localization
   (which still needs a country_code). Only the presentation changes:

     1. one row per currency — never two rows resolving to the same currency
     2. rows read "EUR €", not "Greece EUR €" (Dawn's .country span is hidden; its own
        .localization-form__currency span is what's left)
     3. the trigger reads "EUR €" too, not "Greece | EUR €"
     4. most common first: EUR, USD, CAD, GBP — no scrolling for the common case
     5. the country search is hidden — noise against ten rows

   Two things this has to survive, both learned the hard way:

   LENIS: the list is max-height/overflow-y:auto and the site runs Lenis momentum scroll, which
   swallows the wheel — the list looked frozen. `data-lenis-prevent` hands the wheel back (same fix
   the cart drawer needed).

   FAIL OPEN: a currency picker must never render empty. If pruning would leave zero rows (Dawn
   changes its markup, data-value moves, a currency gets disabled in Markets), we restore every row
   rather than show a blank panel. Re-runs on open and on any re-render, not just once at load.

   ORDER = one country per currency enabled in Admin → Markets. NOTE: AUD is not enabled there, so
   Australia currently prices in EUR and there is no AUD row to show. Enable AUD in Markets first,
   then add 'AU' below. */
(function () {
  'use strict';

  var ORDER = [
    'GR', // EUR — home currency
    'US', // USD — biggest market
    'CA', // CAD
    'GB', // GBP
    'DK', // DKK
    'SE', // SEK
    'CZ', // CZK
    'PL', // PLN
    'HU', // HUF
    'RO'  // RON
  ];

  function css() {
    if (document.getElementById('anemoia-cur-css')) return;
    var s = document.createElement('style');
    s.id = 'anemoia-cur-css';
    s.textContent = [
      // Show the currency, not the country — many countries share one currency.
      'localization-form .disclosure__link .country{display:none !important;}',
      // THE FIX: Dawn ships .localization-form__currency at opacity:0 and only fades it in on
      // hover, because Dawn expects the COUNTRY to be the visible label. We hide the country, so
      // without this line every row renders BLANK — the text is present, just fully transparent.
      'localization-form .disclosure__link .localization-form__currency{opacity:1 !important;margin-left:0 !important;}',
      // Collapse the wide column Dawn reserved for country names so the panel hugs "EUR €".
      'localization-form .disclosure__link{grid-template-columns:14px auto !important;column-gap:10px !important;}',
      // Ten short rows fit comfortably — nobody should scroll to find their currency.
      'localization-form .disclosure__list{max-height:none !important;min-width:0 !important;width:auto !important;}',
      // ...but the WRAPPER has its own max-height:275px + overflow:hidden, which silently CLIPPED
      // the last four currencies. They rendered, then got cut off, so clicks fell through to the
      // page behind them. Both caps must go, not just the list's.
      'localization-form .disclosure__list-wrapper{max-height:none !important;overflow:visible !important;}',
      // The announcement bar sits in a section stacked BELOW the header (4 vs 100), so the panel
      // opened *underneath* the header and the first row — EUR — was painted behind the cart/
      // wishlist icons and could not be clicked. You could switch away from EUR but never back.
      // Lifting the whole section above the header is the only fix that escapes: raising the
      // wrapper alone does nothing, because it can't outrank the header from inside its section.
      '.announcement-bar-section{position:relative !important;z-index:200 !important;}'
    ].join('');
    document.head.appendChild(s);
  }

  function prune(form) {
    var list = form.querySelector('.disclosure__list');
    var items = form.querySelectorAll('.disclosure__item');
    if (!list || !items.length) return;

    if (!list.hasAttribute('data-lenis-prevent')) list.setAttribute('data-lenis-prevent', '');

    var kept = 0;
    Array.prototype.forEach.call(items, function (li) {
      var a = li.querySelector('a[data-value]');
      var keep = !!a && ORDER.indexOf(a.getAttribute('data-value')) !== -1;
      if (keep) kept++;
      li.style.display = keep ? '' : 'none';
    });

    // Fail open: never leave the shopper with an empty currency list.
    if (kept === 0) {
      Array.prototype.forEach.call(items, function (li) { li.style.display = ''; });
      return;
    }

    // Most common first. Re-appending in ORDER also lifts them above the hidden rows.
    if (!list.hasAttribute('data-anemoia-sorted')) {
      ORDER.forEach(function (code) {
        var a = list.querySelector('a[data-value="' + code + '"]');
        var li = a && a.closest('.disclosure__item');
        if (li) list.appendChild(li);
      });
      list.setAttribute('data-anemoia-sorted', '');
    }

    // "Greece | EUR €" → "EUR €"
    var btn = form.querySelector('.disclosure__button');
    var label = btn && btn.querySelector('span');
    if (label) {
      var txt = (label.textContent || '').trim();
      if (txt.indexOf('|') !== -1) label.textContent = txt.split('|').pop().trim();
    }

    var search = form.querySelector('.country-filter, input[type="text"], input[type="search"]');
    if (search) {
      var box = (search.closest && search.closest('.country-filter')) || search;
      box.style.display = 'none';
    }
  }

  function run() {
    css();
    Array.prototype.forEach.call(document.querySelectorAll('localization-form'), prune);
  }

  function boot() {
    run();
    // Re-apply whenever the disclosure opens. Capture, because the disclosure stops some clicks.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('localization-form')) setTimeout(run, 0);
    }, true);
    // And whenever Dawn re-renders a list (the reason a stale panel could ever show through).
    Array.prototype.forEach.call(document.querySelectorAll('localization-form'), function (form) {
      try { new MutationObserver(function () { prune(form); }).observe(form, { childList: true, subtree: true }); } catch (e) {}
    });
    // The header/announcement bar can mount late.
    var n = 0, iv = setInterval(function () { run(); if (++n > 25) clearInterval(iv); }, 400);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
